import Certified from "nvent-web/assets/png/certified.png";
import type { KnownLocale } from "nvent-web/i18n";

export const getLogoByCountryCode = async (locale: KnownLocale): Promise<string> => {
  try {
    if (!locale) {
      return Certified;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    return (await import(`nvent-web/assets/png/certified-${locale.toLowerCase()}.png`)).default;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return Certified;
  }
};
